
import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';
import { convertToArabicNumber } from '@/helpers/convertToArabicNumber';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data(): { arabicAddress: string } {
    return { arabicAddress: '' }
  },
  computed: {
    cnDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    customerDetails: function(): any {
      return this.getVariable(this.input.config.customerDetailsVariable);
    },
    cnType: function(): string {
      return this.cnDetails.discountType || this.cnDetails.subtype;
    },
    billingAddress: function(): string {
      if(_.get(this.customerDetails, `address.alias_en`)) {
        return _.get(this.customerDetails, `address.alias_en`);
      } else {
        return _.get(this.customerDetails, 'address.formatted_address', '');
      }
    },
    nationalAddress: function(): { en: string, ar: string } | null {
      const nationalAddress = _.get(this.customerDetails, 'nationalAddress', '');
      if(!nationalAddress || !nationalAddress.en) return null;
      const engAddress = `${nationalAddress.en.buildNumber}, ${nationalAddress.en.streetName}, ${nationalAddress.en.district}, ${nationalAddress.en.cityName}, ${nationalAddress.en.countryCode} - ${nationalAddress.en.postalCode}`;
      const arabicAddress = `${nationalAddress.ar.buildNumber} ,${nationalAddress.ar.streetName} ,${nationalAddress.ar.district} ,${nationalAddress.ar.cityName} ,${nationalAddress.ar.countryCode} - ${nationalAddress.ar.postalCode}`;
      return { en: engAddress, ar: arabicAddress };
    },
    arabicReason: function(): string {
      const cnReasonsArray: { en: string, ar: string }[] = this.getVariable(this.input.config.creditNoteReasonsVariable);
      const matchedCnReason = cnReasonsArray.find((reason: { en: string, ar: string }) => reason.en == this.cnDetails.reason);
      return matchedCnReason ? matchedCnReason.ar : this.cnDetails.reason;
    }
  },
  watch: {
    async customerDetails() {
      if(!this.arabicAddress) {
        if(_.get(this.customerDetails, `address.alias_ar`)) {
          this.arabicAddress = _.get(this.customerDetails, `address.alias_ar`);
        } else {
          this.arabicAddress = await this.getArabicAddress(this.customerDetails.address.formatted_address);
        }
      }
    }
  },
  methods: {
    async getArabicAddress(searchString: string): Promise<string> {
      const apiResponse: any = await axios
        .get(`https://maps.google.com/maps/api/geocode/json?address=${searchString}&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&language=ar-SA`);
      return apiResponse.data.results[0].formatted_address;
    },
    convertToArabicNo: function(numValue: number): string {
      return convertToArabicNumber(numValue);
    },
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
